import { Icon } from '@mui/material';
import { QRCode } from 'antd';

import '../../../shared/css/ui.css';
import '../../css/AppPromoCard.css';

const APP_LINK = 'https://nabook.onelink.me/cyS5/r9swckn1';

const BENEFITS = [
  'Un épisode gratuit à lire chaque jour',
  'Plus de 300 séries exclusives',
  'Un meilleur confort de lecture',
];

const AppPromoCard = () => {
  return (
    <section className="nbk-card nbk-promo" aria-labelledby="nbk-promo-title">
      <a className="nbk-promo__qr" href={APP_LINK} target="_blank" rel="noreferrer" aria-label="Télécharger l'application Nabook">
        <QRCode size={132} value={APP_LINK} bgColor="white" bordered={false} />
      </a>
      <div className="nbk-promo__content">
        <h2 id="nbk-promo-title" className="nbk-card__title">
          Encore plus d'histoires sur l'appli
        </h2>
        <ul className="nbk-promo__list">
          {BENEFITS.map(benefit => (
            <li key={benefit}>
              <Icon aria-hidden="true">check_circle</Icon>
              <span>{benefit}</span>
            </li>
          ))}
        </ul>
        <p className="nbk-promo__hint">Scannez le QR code avec l'appareil photo de votre téléphone.</p>
        <a className="nbk-btn nbk-btn--secondary nbk-promo__cta" href={APP_LINK} target="_blank" rel="noreferrer">
          Télécharger l'application
        </a>
      </div>
    </section>
  );
};

export default AppPromoCard;
